import React from "react";
import { Helmet } from "react-helmet";
import PageBanner from "../../components/body/PageBanner";
import { APP_NAME } from "../../utils/appName";
import post_1 from "../../assets/images/posts/galeria/post_1.jpeg";
import post_2 from "../../assets/images/posts/galeria/post_2.jpeg";
import post_3 from "../../assets/images/posts/galeria/post_3.jpeg";
import post_4 from "../../assets/images/posts/galeria/post_4.jpeg";
import post_5 from "../../assets/images/posts/galeria/post_5.jpeg";
import post_6 from "../../assets/images/posts/galeria/post_6.jpeg";
import post_8 from "../../assets/images/posts/galeria/post_8.jpeg";
import post_9 from "../../assets/images/posts/galeria/post_9.jpeg";

import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow, Pagination, Autoplay } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";

const galeriaData = [
  {
    photo: post_1,
    title: "Galería de fotos 1",
  },
  {
    photo: post_2,
    title: "Galería de fotos 2",
  },
  {
    photo: post_3,
    title: "Galería de fotos 3",
  },
  {
    photo: post_4,
    title: "Galería de fotos 4",
  },
  {
    photo: post_5,
    title: "Galería de fotos 5",
  },
  {
    photo: post_6,
    title: "Galería de fotos 6",
  },
  {
    photo: post_8,
    title: "Galería de fotos 8",
  },
  {
    photo: post_9,
    title: "Galería de fotos 9",
  },
];

function Galeria() {
  return (
    <>
      <Helmet>
        <title>Galería de Fotos - {APP_NAME}</title>
      </Helmet>
      <PageBanner title="Galería de Fotos" />

      <div className="tp-project-area p-relative pt-80 pb-80" style={{ background: "linear-gradient(135deg, #fdfbfb 0%, #ebedee 100%)", overflow: "hidden" }}>
        <div className="container">
          <div className="row">
            <div className="col-xl-12">
              <div className="tp-project-section-title text-center mb-55">
                <span className="tp-section-subtitle-2" style={{ color: "#d32f2f", fontWeight: "bold", letterSpacing: "2px" }}>Nuestras Actividades</span>
                <h4 className="tp-section-title" style={{ fontSize: "3rem", textShadow: "1px 1px 2px rgba(0,0,0,0.1)" }}>
                  Día de la Bandera
                </h4>
              </div>
            </div>
          </div>
          
          <div className="row">
            <div className="col-12">
              <Swiper
                effect={'coverflow'}
                grabCursor={true}
                centeredSlides={true}
                slidesPerView={'auto'}
                coverflowEffect={{
                  rotate: 35,
                  stretch: 0,
                  depth: 250,
                  modifier: 1,
                  slideShadows: true,
                }}
                autoplay={{
                  delay: 3000,
                  disableOnInteraction: false,
                }}
                pagination={{ clickable: true, dynamicBullets: true }}
                modules={[EffectCoverflow, Pagination, Autoplay]}
                className="mySwiper"
                style={{ padding: "50px 0" }}
              >
                {galeriaData.map((item, index) => (
                  <SwiperSlide key={index} style={{ width: "350px", height: "450px" }}>
                    <div style={{ width: "100%", height: "100%", borderRadius: "20px", overflow: "hidden", position: "relative", boxShadow: "0 15px 35px rgba(0,0,0,0.2)", cursor: "pointer" }}>
                      <img src={item.photo} alt={item.title} loading="lazy" style={{ width: "100%", height: "100%", objectFit: "cover", transition: "transform 0.4s ease" }} onMouseOver={e => e.currentTarget.style.transform = "scale(1.05)"} onMouseOut={e => e.currentTarget.style.transform = "scale(1)"} />
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default React.memo(Galeria);
